import type { Dictionnaire } from '../type';
import { compte } from './pluriel';

export const temps: Dictionnaire['temps'] = {
  ilYa: {
    instant: 'الآن',
    minutes: (n: number) => `منذ ${n} د`,
    heures: (n: number) => `منذ ${n} س`,
    jours: (n: number) => `منذ ${compte(n, 'يوم', 'يومين', 'أيام', 'يومًا')}`,
    semaines: (n: number) => `منذ ${compte(n, 'أسبوع', 'أسبوعين', 'أسابيع', 'أسبوعًا')}`,
    mois: (n: number) => `منذ ${compte(n, 'شهر', 'شهرين', 'أشهر', 'شهرًا')}`,
    ans: (n: number) => `منذ ${compte(n, 'سنة', 'سنتين', 'سنوات', 'سنة')}`,
  },
  hier: 'أمس',
  Hier: 'أمس',
  aujourdhui: 'اليوم',
  heure: {
    pleine: (h: number) => `${String(h).padStart(2, '0')}:00`,
    avecMinutes: (h: number, minutes: string) => `${String(h).padStart(2, '0')}:${minutes}`,
  },
  masqueDate: 'DD / MM / YYYY',
  aujourdhuiMin: 'اليوم',
};
